<template>
  <div class="growup-record-comp">
    <div
      v-for="(item) in list"
      :key="item.id"
      class="growup-record-item"
      @click="showDetail(item)">
      <div class="flex-between">
        <span class="tag">{{ item.baseArchivesTypeName }}</span>
        <van-icon name="arrow" color="var(--g5)" v-if="canGoDetail"></van-icon>
      </div>
      <vx-mult-input-intro :list="item.content.list"></vx-mult-input-intro>
      <div class="card-bottom van-hairline--top flex-between">
        <div class="desc-line">{{ item.createTime | formatDatetime('yyyy-MM-dd') }}</div>
        <div class="desc-line">{{ item.operatorName }}</div>
      </div>
    </div>
    <van-empty
      image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
      description="当前还没有成长记录"
      v-if="!list||(list&&list.length==0)"
      image-size="128">
    </van-empty>
  </div>
</template>

<script>
export default {
  name: 'growup-record-comp',
  props: {
    list: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    canGoDetail() {
      return app.permission.op('query_archives_grow_up');
    }
  },
  methods: {
    showDetail(item) {
      if (this.canGoDetail) {
        this.$router.push(`/growup-record-detail/${item.id}`);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.growup-record-comp {
  .growup-record-item {
    margin: calc(var(--gap) * 16) calc(var(--gap) * 16) calc(var(--gap) * 12);
    padding: calc(var(--gap) * 8) calc(var(--gap) * 16) 0 calc(var(--gap) * 16);
    border-radius: var(--radius-sm);
    background-color: var(--white);
    .tag {
      padding: 0 calc(var(--gap) * 4);
      font-size:var(--fs-sm);
      line-height:var(--lh-sm);
      border: 1px solid var(--c1);
      color: var(--c1);
      border-radius: 2px;
    }
    .card-bottom {
      padding: calc(var(--gap) * 8) 0;
      .desc-line {
        color: var(--g6);
        font-size: var(--fs-sm);
        line-height: var(--lh-sm);
      }
    }
  }
}
</style>